import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFundCard = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={320} height={150} fill='none' {...props}>
    <defs>
      <linearGradient id='FundCard_svg__grad' x1='0%' y1='0%' x2='100%' y2='0%'>
        <stop offset='3.76%' stopColor='rgb(var(--blue-1))' />
        <stop offset='98.74%' stopColor='#00467F' />
      </linearGradient>
    </defs>
    <mask
      id='FundCard_svg__a'
      width={320}
      height={150}
      x={0}
      y={0}
      maskUnits='userSpaceOnUse'
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill='#fff'
        d='M300 0H20C8.954 0 0 8.954 0 20v110c0 11.046 8.954 20 20 20h280c11.046 0 20-8.954 20-20V20c0-11.046-8.954-20-20-20'
      />
    </mask>
    <g mask='url(#FundCard_svg__a)'>
      <path
        fill='url(#FundCard_svg__grad)'
        d='M300 0H20C8.954 0 0 8.954 0 20v110c0 11.046 8.954 20 20 20h280c11.046 0 20-8.954 20-20V20c0-11.046-8.954-20-20-20'
      />
      <mask
        id='FundCard_svg__b'
        width={167}
        height={167}
        x={-74}
        y={-65}
        maskUnits='userSpaceOnUse'
        style={{
          maskType: 'luminance',
        }}
      >
        <path fill='#fff' d='M93-65H-74v167H93z' />
      </mask>
      <g fill='#fff' mask='url(#FundCard_svg__b)' opacity={0.1}>
        <path d='M93 18.426H59.8C59.77-9.324 37.235-31.8 9.485-31.8c-7.07 0-13.786 1.443-19.855 4.094a50.15 50.15 0 0 0-20.326 15.967C-37.03-3.343-40.771 7.114-40.8 18.426v.089c0 27.78 22.506 50.285 50.285 50.285 7.04 0 13.728-1.443 19.796-4.035l13.11 30.518a83.3 83.3 0 0 1-32.906 6.746C-36.617 102-74 64.617-74 18.515v-.089c.03-18.824 6.245-36.175 16.762-50.138a83.6 83.6 0 0 1 33.76-26.513A83.2 83.2 0 0 1 9.484-65C55.588-65 92.971-27.647 93 18.426' />
        <path d='M59.8 18.427v.088c0 20.739-12.578 38.561-30.489 46.25L9.427 18.427z' />
      </g>
    </g>
  </svg>
);
export default SvgFundCard;
